import {
  FETCH_ANALYTICS_USER_LOGS,
  FETCH_CLICKUP_USERS,
  FETCH_SCOUT_USERS,
  FETCH_USERS
} from "./actions"
import { PaginatedData } from "../../types/root"
import { User, UsersActionProps, UsersProps } from "../../types/users"

export const initialUsersState: UsersProps = {
  paginatedUsers: new PaginatedData<User>(),
  clickupUsers: new PaginatedData<User>(),
  scoutUsers: new PaginatedData<User>(),
  analyticsUserLogs: new PaginatedData<User>()
}

const users = (state = initialUsersState, action: UsersActionProps) => {
  switch (action.type) {
    case FETCH_USERS: {
      const paginatedUsers = (action.payload?.paginatedUsers as PaginatedData<User>) || new PaginatedData<User>()
      return {
        ...state,
        paginatedUsers
      }
    }
    case FETCH_CLICKUP_USERS: {
      const clickupUsers = (action.payload?.clickupUsers as PaginatedData<User>) || new PaginatedData<User>()
      return {
        ...state,
        clickupUsers
      }
    }
    case FETCH_SCOUT_USERS: {
      const scoutUsers = (action.payload?.scoutUsers as PaginatedData<User>) || new PaginatedData<User>()
      return {
        ...state,
        scoutUsers
      }
    }
    case FETCH_ANALYTICS_USER_LOGS: {
      const analyticsUserLogs = (action.payload?.analyticsUserLogs as PaginatedData<User>) || new PaginatedData<User>()
      return {
        ...state,
        analyticsUserLogs
      }
    }
    default: {
      return { ...state }
    }
  }
}

export default users
